<template>
  <v-dialog v-model="warningDialog" persistent width="500" hide-overlay>
    <v-alert type="warning" class="mb-0 font-weight-bold">{{ $t('settings/settings:duplicate.preview.warning-dialog.alert') }}</v-alert>
    <v-card>
      <v-card-title>{{ $t('settings/settings:duplicate.preview.warning-dialog.title', { name: objectTranslation }) }}</v-card-title>
      <v-card-subtitle>{{ $t('settings/settings:duplicate.preview.warning-dialog.subtitle', { name: objectTranslation }) }}</v-card-subtitle>
      <v-card-text>
        <v-list color="grey lighten-3">
          <v-list-item v-for="(item, index) in objectsToRemoveNames" :key="index" class="greyBold--text">
            {{ item }}
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions class="px-5">
        <v-spacer></v-spacer>
        <v-btn
            color="warning"
            @click="$emit('confirmMerge')"
            rounded
            elevation="0"
        >
          {{ $t('buttons:confirm') }}
        </v-btn>

        <v-btn
            color="greyTint"
            @click="closeDialog"
            outlined
            rounded
        >
          {{ $t('buttons:cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "MergeWarningDialog",
  props: {
    objectsToRemoveNames: Array,
    objectTranslation: String
  },
  data() {
    return {
      warningDialog: false
    }
  },
  methods: {
    openDialog() {
      this.warningDialog = true;
    },
    closeDialog() {
      this.warningDialog = false;
    }
  }
}
</script>